import React from 'react';
import './Select.less';

//TODO cancel dropdown styling in Firefox
export const Select = ({items, selectedItemId, onChange}) => {
	return (<select className="select" onChange={e => onChange(e.target.value)}>
		{
			items.map(item => {
				return (<option value={item.id} selected={item.id === selectedItemId}>{item.name}</option>)
			})
		}
	</select>)
}
